import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Facebook, Linkedin, Twitter } from 'lucide-react';
import { companyInfo, banks } from '../data/mock';

const Footer = () => {
  const quickLinks = [
    { path: '/', label: 'Home' },
    { path: '/about', label: 'About Valuer' },
    { path: '/services', label: 'Services' },
    { path: '/process', label: 'Valuation Process' }
  ];

  const resources = [
    // { path: '/price-trends', label: 'Price Trends' },
    { path: '/certificates', label: 'Certificates' },
    { path: '/contact', label: 'Contact Us' }
  ];

  return (
    <footer className="bg-primary text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8 mt-4">
          {/* Company Info */}
          <div>
            <h3 className="text-accent text-xl font-bold mb-4 mt-4">{companyInfo.name}</h3>
            <p className="text-white/90 text-sm mb-4">
              {companyInfo.tagline}
            </p>
            <p className="text-white/90 text-sm mb-4">
              {companyInfo.experience} of trusted property valuation services across Gujarat.
            </p>
            <div className="flex gap-3">
              <a href="#" className="text-white hover:text-accent transition-colors" aria-label="Facebook">
                <Facebook size={20} />
              </a>
              <a href="#" className="text-white hover:text-accent transition-colors" aria-label="LinkedIn">
                <Linkedin size={20} />
              </a>
              <a href="#" className="text-white hover:text-accent transition-colors" aria-label="Twitter">
                <Twitter size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-accent font-semibold mb-4 mt-4">Quick Links</h4>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-white/90 hover:text-accent text-sm transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h4 className="text-accent font-semibold mb-4 mt-4">Resources</h4>
            <ul className="space-y-2">
              {resources.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-white/90 hover:text-accent text-sm transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-accent font-semibold mb-4 mt-4">Contact Us</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2 text-white/90 text-sm">
                <MapPin size={16} className="text-white mt-1 flex-shrink-0" />
                <span>{companyInfo.address}</span>
              </li>
              <li className="flex items-center gap-2 text-white/90 text-sm">
                <Phone size={16} className="text-white flex-shrink-0" />
                <a href={`tel:${companyInfo.mobile}`} className="hover:text-accent transition-colors">
                  {companyInfo.mobile}
                </a>
              </li>
              {/* <li className="flex items-center gap-2 text-white/90 text-sm">
                <Phone size={16} className="text-white flex-shrink-0" />
                <a href={`tel:${companyInfo.alternateMobile}`} className="hover:text-accent transition-colors">
                  {companyInfo.alternateMobile}
                </a>
              </li> */}
              <li className="flex items-center gap-2 text-white/90 text-sm">
                <Mail size={16} className="text-white flex-shrink-0" />
                <a href={`mailto:${companyInfo.email}`} className="hover:text-accent transition-colors">
                  {companyInfo.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bank Partners */}
        <div className="border-t border-border pt-8 mb-8">
          <h4 className="text-white font-semibold mb-4 text-center">Empanelled Banks & Financial Institutions</h4>
          <div className="flex flex-wrap justify-center gap-4 text-white/80 text-xs">
            {banks.slice(0, 8).map((bank, index) => (
              <span key={index}>{bank}</span>
            ))}
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-border pt-6 text-center">
          <p className="text-white/80 text-sm">
            © {new Date().getFullYear()} {companyInfo.name}. All rights reserved.
          </p>
          <p className="text-white/70 text-xs mt-2">
            Government Registered Valuer | Income Tax Act 34AB | RVO Certified
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
